import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    backgoround: theme.palette.primaryDark,
    // minHeight: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    position: 'relative',
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  buttonsContainer: {
    minWidth: "200px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  noResult: {
    width: "100%",
    textAlign: "center",
    marginTop: "40px",
    color: theme.palette.notFoundBrown,
    ...theme.typography.h5
  },
  drawer: {
    backgroundColor: theme.palette.secondaryDark
  }
}));
